import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import AuthGuard from 'utils/route-guard/AuthGuard';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));

// render - batches
const BatchesPage = Loadable(lazy(() => import('pages/batches')));
const BatchViewPage = Loadable(lazy(() => import('pages/batches/View')));

// render - locations, hatchery, input stock, suppliers, alerts
const LocationsPage = Loadable(lazy(() => import('pages/locations')));
const HatcheryPage = Loadable(lazy(() => import('pages/hatchery')));
const InputStockPage = Loadable(lazy(() => import('pages/input-stock')));
const InputStockViewPage = Loadable(lazy(() => import('pages/input-stock/View')));
const SuppliersPage = Loadable(lazy(() => import('pages/suppliers')));
const SupplierViewPage = Loadable(lazy(() => import('pages/suppliers/View')));
const AlertsPage = Loadable(lazy(() => import('pages/alerts')));

// render - profile
const ProfilePage = Loadable(lazy(() => import('pages/profile')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <DashboardLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'batches',
      element: <BatchesPage />
    },
    {
      path: 'batches/:id',
      element: <BatchViewPage />
    },
    {
      path: 'locations',
      element: <LocationsPage />
    },
    {
      path: 'hatchery',
      element: <HatcheryPage />
    },
    {
      path: 'input-stock',
      element: <InputStockPage />
    },
    {
      path: 'input-stock/:id',
      element: <InputStockViewPage />
    },
    {
      path: 'suppliers',
      element: <SuppliersPage />
    },
    {
      path: 'suppliers/:id',
      element: <SupplierViewPage />
    },
    {
      path: 'alerts',
      element: <AlertsPage />
    },
    {
      path: 'profile',
      element: <ProfilePage />
    }
  ]
};

export default MainRoutes;
